module.exports = __webpack_public_path__ + "static/media/4.a5b70f67.png";